import { createFileRoute, redirect } from '@tanstack/react-router';

// 公共着陆页（`/`）托管内嵌登录表单，因此 `/login` 直接
// 重定向到那里——对应原 Next 应用，保持所有现有跳转到登录
// （认证守卫、登出、客户端认证失败）不变。
export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
